exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".question-properties[data-v-95832f20]{opacity:.3;text-align:right;margin-bottom:5px}.question-properties .badge[data-v-95832f20]{margin-left:10px}.question-properties .badge span[data-v-95832f20]{font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-95832f20","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/userAnswer/Card.vue
// module id = 1065
// module chunks = 0